import axios from "axios";
import { BaseUrl, FormConfig, JsonConfig, UserName } from "./BaseRepository"
import { ErrorMessage, SuccessMessage } from "../Utils/Utils";

export const FetchEADColumns = async(setDynamicColumns, setLoadGrid) => {
    try{
        setLoadGrid(true);
        const URL = `${BaseUrl}Adjustments/getadjustmentheaderscodes`;
        const Response = await axios.get(URL, JsonConfig);
        if(Response != null){
            setDynamicColumns(JSON.parse(Response.data.payload));
            return;
        }
    }
    catch{
        ErrorMessage("Unable to get Columns!!!");
    }
    finally{
        setLoadGrid(false);
    }
}

export const FetchAdjustmentsData = async(frequency, setLoadGrid, setDataSource) =>{
    try{
        setLoadGrid(true);
        const URL = `${BaseUrl}Adjustments/getadjustmentdata?frequency=${frequency}`;
        const Response = await axios.get(URL, JsonConfig);
        if(Response != null){
            setDataSource(JSON.parse(Response.data.payload));
            return ;
        }
    }
    catch{
        ErrorMessage("Unable to get Adjustments!!!");
    }
    finally{
        setLoadGrid(false);
    }
}

export const PostAdjustmentsExcel = async(frequency, File)=>{
    try{
        const URL = `${BaseUrl}Adjustments/uploadadjustment/${frequency}?userName=${UserName}`;
        const Response = await axios.post(URL, File, FormConfig);
        if(Response != null){
            return Response.data;
        }
        else{
            throw "Unable to upload";
        }
    }
    catch{
        throw "Unable to upload";
    }
}

export const FetchHistoricAdjustmentsData = async(date, frequency, setLoadGrid, setDataSource) =>{
    try{
        setLoadGrid(true);
        const URL = `${BaseUrl}Adjustments/getadjustmenthistoricdata/${frequency}`;
        const Response = await axios.post(URL, {Data:date}, JsonConfig);
        if(Response != null){
            setDataSource(JSON.parse(Response.data.payload));
            return ;
        }
    }
    catch{
        ErrorMessage("Unable to get Adjustments!!!");
    }
    finally{
        setLoadGrid(false);
    }
}

export const DiscardAdjustmentsData = async(frequency) =>{
    try{
        const URL = `${BaseUrl}Adjustments/discardadjustments/${frequency}`;
        const Response = await axios.post(URL, {Data:UserName}, JsonConfig);
        if(Response != null){
            if(Response.data.statusCode===200){
                SuccessMessage(Response.data.message);
            }
            else{
                ErrorMessage(Response.data.message);
            }
        }
        else{
            throw "Unable to upload";
        }
    }
    catch{
        throw "Unable to upload";
    }
}

export const DeleteAdjustment = async(id) =>{
    try{
        const URL = `${BaseUrl}Adjustments/deletesingleadjustment/${id}`;
        const Response = await axios.delete(URL, JsonConfig);
        if(Response != null){
            return Response.data;
        }
        return null;
    }
    catch{
        ErrorMessage("Unable to delete Adjustment!!!")
    }
}

export const UpdateAdjustment = async(record) =>{
    try{
        const URL = `${BaseUrl}Adjustments/updatesingleadjustment/${UserName}`;
        const Response = await axios.put(URL, {Data:JSON.stringify(record)}, JsonConfig);
        if(Response != null){
            return Response.data;
        }
        return null;
    }
    catch{
        ErrorMessage("Unable to update Adjustment!!!")
    }
}

export const GetFileNumberForAdjustment = async(fileNumber) =>{
    try{
        const URL = `${BaseUrl}Adjustments/getfilenumberdata/${fileNumber}`;
        const Response = await axios.get(URL, JsonConfig);
        if(Response != null){
            return Response.data;
        }
        return null;
    }
    catch{
        ErrorMessage("Unable to update Adjustment!!!")
    }
}

export const PostNewAdjustment = async(record, frequency) =>{
    try{
        const URL = `${BaseUrl}Adjustments/addsingleadjustment/${frequency}/${UserName}`;
        const Response = await axios.post(URL, {Data:JSON.stringify(record)}, JsonConfig);
        if(Response != null){
            return Response.data;
        }
        return null;
    }
    catch{
        ErrorMessage("Unable to add Adjustment!!!")
    }
}

export const RollBackAdjustment = async(record) => {
    try{
        let URL = `${BaseUrl}Adjustments/rollbackadjustments/${UserName}`;
        const Response = await axios.post(URL, {Data:record.Ticket_Number}, JsonConfig);
        if(Response != null){
            if(Response.data.statusCode === 200){
                SuccessMessage(Response.data.message);
            } 
            else{
                ErrorMessage(Response.data.message);
            }
        }
    }
    catch{
        ErrorMessage("Unable to rollback Adjustment!!!");
    }
}

export const SaveAdjustmentsToMaster = async(frequency) => {
    try{
        let URL = `${BaseUrl}Adjustments/saveadjustmentstomaster/${frequency}/${UserName}`;
        const Response = await axios.post(URL, {}, JsonConfig);
        if(Response != null){
            if(Response.data.statusCode === 200){
                SuccessMessage(Response.data.message);
            } 
            else{
                ErrorMessage(Response.data.message);
            }
        }
    }
    catch{
        ErrorMessage("Unable to save adjustments to master!!!");
    }
}